<template>
    <div>
      <form class="uk-card uk-card-default uk-card-body uk-margin-top" @submit="submitForm($event)">
        <legend class="uk-legend">Login</legend>
        <hr>
        <ci-input
          name="username"
          label="username"
          placeholder="Enter your username…"
          type="text"
          @change="keyChange">
        </ci-input>
        <ci-input
          name="password"
          label="password"
          placeholder="Enter your password…"
          type="password"
          @change="keyChange">
        </ci-input>
        <button class="btn btn-primary">
          Submit
        </button>
      </form>
    </div>
</template>

<script>
import Input from '@/elements/Input.vue';
import UserService from '@/services/UserService';

export default {
  name: 'FormLogin',
  components: {
    'ci-input': Input,
  },
  data() {
    return {
      username: null,
      password: null,
    };
  },
  methods: {
    keyChange(payload) {
      if (payload.isValid) {
        this.$set(this, payload.key, payload.data);
      }
    },

    submitForm(evt) {
      evt.preventDefault();
      UserService.login({
        username: this.username,
        password: this.password,
      }).then(() => {
        this.$router.push({ path: '/users/overview' });
      });
    },
  },
};
</script>
